import { RouterView } from "vue-router";
import { ETAB_ROUTES, ETAB_LAYOUTS, META_BACK } from "@etab/config";
import { META_LAYOUT, META_HEADER_TITLE } from "@core/constants";
import { LoadingManager } from "@core/managers/loading.manager";
import { NotificationsManager } from "@core/managers/notifications.manager";
import { ACTION_RECRUITMENT_GET } from "@etab/stores/types";
import { useRecruitmentStore } from "@etab/stores/recruitment";
import ActivationPermanent from "./ActivationPermanent.page.vue";
import SuccessPage from "./ActivationSuccess.page.vue";

export default function () {
  return [
    {
      path: ETAB_ROUTES.dashboard.recruitment.permanent.activation.root.path,
      name: ETAB_ROUTES.dashboard.recruitment.permanent.activation.root.name,
      component: RouterView,
      children: [
        {
          path: ETAB_ROUTES.dashboard.recruitment.permanent.activation.payment.path,
          name: ETAB_ROUTES.dashboard.recruitment.permanent.activation.payment.name,
          meta: {
            [META_LAYOUT]: ETAB_LAYOUTS.pricing,
            [META_HEADER_TITLE]: "",
            [META_BACK]: true,
          },
          component: ActivationPermanent,
        },
        {
          path: ETAB_ROUTES.dashboard.recruitment.permanent.activation.success.path,
          name: ETAB_ROUTES.dashboard.recruitment.permanent.activation.success.name,
          component: SuccessPage,
          async beforeEnter(to, from, next) {
            const recruitmentStore = useRecruitmentStore();
            try {
              LoadingManager.show();
              const demandId = to.params.demandId;
              const demandType = to.params.demandType;
              await recruitmentStore[ACTION_RECRUITMENT_GET]({ demandId, demandType });
              next();
            } catch (error) {
              NotificationsManager.error();
              next({ name: ETAB_ROUTES.dashboard.tabs.root.name });
              throw error;
            } finally {
              LoadingManager.hide();
            }
          },
        },
      ],
    },
  ];
}
